export default __webpack_public_path__ + "static/media/jp-yen.1d6736b5.svg";